import PropTypes from 'prop-types'
import { auctionStates } from '../services/constants'

export const idShape = PropTypes.oneOfType([
  PropTypes.number.isRequired,
  PropTypes.string.isRequired
])

export const charityShape = PropTypes.shape({
  description: PropTypes.string,
  facebook: PropTypes.string,
  googlePlus: PropTypes.string,
  id: idShape,
  instagram: PropTypes.string,
  lat: PropTypes.string,
  lng: PropTypes.string,
  location: PropTypes.string,
  name: PropTypes.string,
  photo: PropTypes.string,
  shortDescription: PropTypes.string,
  twitter: PropTypes.string,
  userId: idShape
})

export const bidShape = PropTypes.shape({
  amount: PropTypes.number,
  userId: idShape
})

// shape from DB
const basicItemShape = PropTypes.shape({
  auctionId: idShape,
  bids: PropTypes.arrayOf(PropTypes.number),
  category: PropTypes.string,
  date: PropTypes.string,
  description: PropTypes.string,
  donor: PropTypes.string,
  id: idShape,
  info: PropTypes.string,
  initialBid: PropTypes.number,
  instructions: PropTypes.string,
  itemNumber: PropTypes.string,
  lat: PropTypes.string,
  lng: PropTypes.string,
  location: PropTypes.string,
  media: PropTypes.arrayOf(PropTypes.objecty),
  title: PropTypes.string
})

// shape from DB
export const basicAuctionShape = PropTypes.shape({
  id: idShape,
  charityId: PropTypes.number,
  title: PropTypes.string,
  description: PropTypes.string,
  lat: PropTypes.string,
  lng: PropTypes.string,
  location: PropTypes.string,
  photo: PropTypes.string,
  startTime: PropTypes.any,
  closeTime: PropTypes.any,
  state: PropTypes.oneOf(auctionStates)
})

export const auctionShape = PropTypes.shape({
  ...basicAuctionShape,
  items: PropTypes.arrayOf(basicItemShape),
  charity: charityShape
})

export const itemShape = PropTypes.shape({
  ...basicItemShape,
  bids: PropTypes.arrayOf(bidShape),
  auction: auctionShape
})

export const socialMediaShape = PropTypes.shape({
  facebook: PropTypes.string,
  twitter: PropTypes.string,
  instagram: PropTypes.string,
  google: PropTypes.string
})



// WEBPACK FOOTER //
// ./src/services/prop-types.js